module.exports = __webpack_public_path__ + "static/media/gb-eng.2d5bac56.svg";